<!-- eslint-disable vue/require-v-for-key -->
<template>
    <div class="inscription container-fluid mx-auto d-flex-center flex-column my-5 flex-fill body-container">
        <div v-if="isLoading" class="loader d-flex-center">
            <div class="loader__frame p-3 pt-4--5">
                <div class="spinner-border" role="status"></div>
                <strong class="mt-3">{{ t.loadingMsg }}</strong>
            </div>
        </div>

        <div class="inscription__container p-3 py-sm-4--5 px-sm-5 shadow rounded-5">
            <h1 class="w-100 mt-3 mb-4--5">{{ t.registerTitle }}</h1>
            <form method="POST" class="inscription__form needs-validation" novalidate>
                <div class="row g-4">
                    <!-- Participation -->
                    <div class="col m-0"></div>
                    <div class="col-12 col-sm-auto d-flex-center text-center fs-4">{{ t.participateLabel }} :</div>
                    <div class="col-12 col-sm-auto text-center">
                        <button
                            type="button"
                            class="btn btn-lg mx-3"
                            v-bind:class="[form_data.is_participating ? 'btn-primary' : 'btn-outline-primary']"
                            @click="participate(true)"
                        >
                            {{ t.yes }}
                        </button>
                        <button
                            type="button"
                            class="btn btn-lg"
                            v-bind:class="[form_data.is_participating ? 'btn-outline-secondary' : 'btn-secondary']"
                            @click="participate(false)"
                        >
                            {{ t.no }}
                        </button>
                    </div>
                    <div class="col m-0"></div>

                    <div class="col-12"></div>
                    <!-- Nom -->
                    <div class="col-12 col-sm-6">
                        <div class="form-floating">
                            <input
                                class="form-control text-uppercase"
                                type="text"
                                v-model="form_data.last_name"
                                id="last_name"
                                name="last_name"
                                placeholder="Dupond"
                                required
                            />
                            <label for="last_name">{{ t.lastNameLabel }}*</label>
                            <div class="invalid-feedback">{{ t.lastNameInvalid }}</div>
                        </div>
                    </div>
                    <!-- Prenom -->
                    <div class="col-12 col-sm-6">
                        <div class="form-floating">
                            <input
                                class="form-control text-capitalize"
                                type="text"
                                v-model="form_data.first_name"
                                id="first_name"
                                name="first_name"
                                placeholder="Alain"
                                required
                            />
                            <label for="first_name">{{ t.firstNameLabel }}*</label>
                            <div class="invalid-feedback">{{ t.firstNameInvalid }}</div>
                        </div>
                    </div>
                    <!-- email -->
                    <div class="col-12">
                        <div class="form-floating">
                            <input
                                class="form-control"
                                type="email"
                                v-model="form_data.email"
                                id="email_address"
                                name="email_address"
                                placeholder="nom@exemple.fr"
                                required
                            />
                            <label for="email_address">{{ t.emailLabel }}*</label>
                            <div class="invalid-feedback">{{ t.emailInvalid }}</div>
                        </div>
                    </div>
                    <!-- Franchise -->
                    <div class="col-12">
                        <div class="form-floating">
                            <input
                                class="form-control"
                                type="text"
                                v-model="form_data.franchised"
                                id="franchised"
                                name="franchised"
                                placeholder="Bordeaux, Dijon, ..."
                                required
                            />
                            <label for="franchised">{{ t.franchisedLabel }}*</label>
                            <div class="invalid-feedback">{{ t.franchisedInvalid }}</div>
                        </div>
                    </div>

                    <template v-if="form_data.is_participating">
                        <div class="col-12">
                            <div class="form-floating">
                                <select
                                    required
                                    v-model="form_data.transport"
                                    class="form-select"
                                    aria-label="Mode de transport utilisé"
                                    id="transport"
                                    name="transport"
                                >
                                    <option value="Train">Train</option>
                                    <option value="Avion">Avion</option>
                                    <option value="Voiture thermique">Voiture thermique</option>
                                    <option value="Voiture électrique">Voiture électrique</option>
                                    <option value="Autre">Autre</option>
                                </select>
                                <label for="transport">Mode de transport utilisé*</label>
                                <div class="invalid-feedback">Veuillez renseigner votre mode de transport</div>
                            </div>
                        </div>

                        <!-- Allergies -->
                        <div class="col-12">
                            <div class="form-floating">
                                <input
                                    class="form-control"
                                    type="text"
                                    v-model="form_data.allergies"
                                    id="allergies"
                                    name="allergies"
                                    placeholder="Arachide, ..."
                                />
                                <label for="allergiesLabel">{{ t.allergiesLabel }}</label>
                            </div>
                        </div>

                        <div
                            class="col-12 col-md-4 d-flex-center flex-column text-center mt-md-4 justify-content-md-start"
                        >
                            <div>Je serai présent(e) le :</div>
                            <div style="font-size: 11px">
                                cochez selon votre présence et renseignez vos informations d'arrivée/départ
                            </div>
                        </div>
                        <div class="j-selector col-6 col-sm d-flex flex-column align-items-stretch">
                            <button
                                type="button"
                                v-on:click="form_data.j1_present = !form_data.j1_present"
                                class="btn btn-lg"
                                v-bind:class="[form_data.j1_present ? 'btn-primary' : 'btn-outline-secondary']"
                            >
                                18 JUIN
                            </button>
                            <input
                                class="form-control rounded-5 bg-transparent text-center my-2 py-0 small"
                                type="text"
                                v-model="form_data.j1_arrival_time"
                                id="j1_arrival_time"
                                name="j1_arrival_time"
                                placeholder="h. arrivée"
                                :disabled="!form_data.j1_present"
                            />
                            <div
                                class="cursor-pointer d-flex align-items-baseline"
                                v-on:click="form_data.j1_diner = form_data.j1_present && !form_data.j1_diner"
                            >
                                <i
                                    class="fa-circle mx-2"
                                    :class="form_data.j1_diner ? 'fa-solid text-primary' : 'fa-regular text-secondary'"
                                ></i>
                                <small>Dîner</small>
                            </div>
                            <div
                                class="cursor-pointer d-flex align-items-baseline"
                                v-on:click="form_data.j1_night = form_data.j1_present && !form_data.j1_night"
                            >
                                <i
                                    class="fa-circle mx-2"
                                    :class="form_data.j1_night ? 'fa-solid text-primary' : 'fa-regular text-secondary'"
                                ></i>
                                <small>Nuitée</small>
                            </div>
                        </div>
                        <div class="j-selector col-6 col-sm d-flex flex-column align-items-stretch">
                            <button
                                type="button"
                                v-on:click="form_data.j2_present = !form_data.j2_present"
                                class="btn btn-lg"
                                v-bind:class="[form_data.j2_present ? 'btn-primary' : 'btn-outline-secondary']"
                            >
                                19 JUIN
                            </button>
                            <input
                                class="form-control rounded-5 bg-transparent text-center my-2 py-0"
                                type="text"
                                v-model="form_data.j2_arrival_time"
                                id="j2_arrival_time"
                                name="j2_arrival_time"
                                placeholder="h. arrivée"
                                :disabled="!form_data.j2_present"
                            />
                             <div
                                class="cursor-pointer d-flex align-items-baseline"
                                v-on:click="form_data.j2_breakfast = form_data.j2_present && !form_data.j2_breakfast"
                            >
                                <i
                                    class="fa-circle mx-2"
                                    :class="form_data.j2_breakfast ? 'fa-solid text-primary' : 'fa-regular text-secondary'"
                                ></i>
                                <small>Petit-déjeuner</small>
                            </div>
                            <div
                                class="cursor-pointer d-flex align-items-baseline"
                                v-on:click="form_data.j2_lunch = form_data.j2_present && !form_data.j2_lunch"
                            >
                                <i
                                    class="fa-circle mx-2"
                                    :class="form_data.j2_lunch ? 'fa-solid text-primary' : 'fa-regular text-secondary'"
                                ></i>
                                <small>Déjeuner</small>
                            </div>
                            <div
                                class="cursor-pointer d-flex align-items-baseline"
                                v-on:click="form_data.j2_diner = form_data.j2_present && !form_data.j2_diner"
                            >
                                <i
                                    class="fa-circle mx-2"
                                    :class="form_data.j2_diner ? 'fa-solid text-primary' : 'fa-regular text-secondary'"
                                ></i>
                                <small>Soirée & nuitée</small>
                            </div>
                        </div>
                        <div class="j-selector col-6 col-sm d-flex flex-column align-items-stretch">
                            <button
                                type="button"
                                v-on:click="form_data.j3_present = !form_data.j3_present"
                                class="btn btn-lg"
                                v-bind:class="[form_data.j3_present ? 'btn-primary' : 'btn-outline-secondary']"
                            >
                                20 JUIN
                            </button>
                            <input
                                class="form-control rounded-5 bg-transparent text-center my-2 py-0"
                                type="text"
                                v-model="form_data.j3_arrival_time"
                                id="j3_arrival_time"
                                name="j3_arrival_time"
                                placeholder="h. départ"
                                :disabled="!form_data.j3_present"
                            />
                            <div
                                class="cursor-pointer d-flex align-items-baseline"
                                v-on:click="form_data.j3_breakfast = form_data.j3_present && !form_data.j3_breakfast"
                            >
                                <i
                                    class="fa-circle mx-2"
                                    :class="
                                        form_data.j3_breakfast ? 'fa-solid text-primary' : 'fa-regular text-secondary'
                                    "
                                ></i>
                                <small>Petit-déjeuner</small>
                            </div>
                            <div
                                class="cursor-pointer d-flex align-items-baseline"
                                v-on:click="form_data.j3_activity = form_data.j3_present && !form_data.j3_activity"
                            >
                                <i
                                    class="fa-circle mx-2"
                                    :class="
                                        form_data.j3_activity ? 'fa-solid text-primary' : 'fa-regular text-secondary'
                                    "
                                ></i>
                                <small>Activité collective en matinée</small>
                            </div>
                        </div>
                        <div class="col-12 m-0"></div>

                        <!-- Is Accompanied -->
                        <template v-if="form_data.is_participating && type_invitation === 1">
                            <div class="col-12 col-sm-auto d-flex-center text-center">{{ t.is_accompanied }} :</div>
                            <div class="col-12 col-sm-auto text-center">
                                <button
                                    type="button"
                                    class="btn me-2"
                                    v-on:click="isAccompaniedChanged(true)"
                                    v-bind:class="[form_data.is_accompanied ? 'btn-primary' : 'btn-outline-primary']"
                                >
                                    {{ t.yes }}
                                </button>
                                <button
                                    type="button"
                                    class="btn"
                                    v-on:click="isAccompaniedChanged(false)"
                                    v-bind:class="[
                                        form_data.is_accompanied ? 'btn-outline-secondary' : 'btn-secondary',
                                    ]"
                                >
                                    {{ t.no }}
                                </button>
                            </div>
                            <div class="col"></div>
                            <div class="col-12 m-0"></div>

                            <template v-if="form_data.is_accompanied">
                                <template v-for="(mate, i) in mates">
                                    <!-- Nom accompagnant -->
                                    <div class="form-floating">
                                        <input
                                            class="form-control text-uppercase"
                                            type="text"
                                            v-model="mate.last_name"
                                            v-bind:id="`last_name_${i}`"
                                            v-bind:name="`last_name_${i}`"
                                            placeholder="Dupont"
                                            required
                                        />
                                        <label v-bind:for="`last_name_${i}`">Nom accompagnant(e)*</label>
                                    </div>
                                    <!-- Prénom accompagnant -->
                                    <div class="form-floating">
                                        <input
                                            class="form-control text-capitalize"
                                            type="text"
                                            v-model="mate.first_name"
                                            v-bind:id="`first_name_${i}`"
                                            v-bind:name="`first_name_${i}`"
                                            placeholder="Dupont"
                                            required
                                        />
                                        <label v-bind:for="`first_name_${i}`">Prénom accompagnant(e)*</label>
                                    </div>
                                </template>
                            </template>
                        </template>
                        <div class="col-12">
                            <div class="form-check me-4">
                                <input
                                    id="chk_confirm"
                                    class="form-check-input"
                                    type="checkbox"
                                    v-model="form_data.confirm_participation"
                                    required
                                />
                                <label class="form-check-label" for="chk_confirm">{{ t.confirmRegister }}*</label>
                            </div>
                        </div>
                        <!-- accept privacy policy -->
                        <div class="col-12">
                            <div class="form-check me-4">
                                <input
                                    id="chk_policy"
                                    class="form-check-input"
                                    type="checkbox"
                                    v-model="form_data.has_accepted_privacy_policy"
                                    required
                                />
                                <label class="form-check-label" for="chk_policy">{{ t.privacyPolicyLabel }}*</label>
                            </div>
                        </div>
                    </template>
                </div>

                <button @click="register" class="w-100 btn btn-primary btn-lg mt-3" type="button">
                    {{ t.validateBtn }}
                </button>
                <div class="mt-2 small">* {{ t.requiredField }}</div>
            </form>
        </div>
    </div>
</template>

<script>
import { t } from "../locale/language";
import router from "../plugins/router";
import { saveRegistration, checkTypeInvitation } from "@/plugins/server";

const empty_form = {
    is_participating: true,
    last_name: "",
    first_name: "",
    email: "",
    has_accepted_privacy_policy: false,
    confirm_participation: false,
    allergies: "",
    franchised: "",
    j1_present: false,
    j1_arrival_time: "",
    j1_diner: false,
    j1_night: false,
    j2_present: false,
    j2_arrival_time: "",
    j2_breakfast: false,
    j2_lunch: false,
    j2_diner: false,
    j3_present: false,
    j3_arrival_time: "",
    j3_breakfast: false,
    j3_activity: false,
    transport: null,
};

export default {
    props: {
        token: null,
    },
    data() {
        return {
            isLoading: false,
            hasError: false,
            t,
            type_invitation: 0, // 0|1
            mates: [],
            form_data: {
                is_participating: true,
                last_name: "",
                first_name: "",
                email: "",
                has_accepted_privacy_policy: false,
                confirm_participation: false,
                allergies: "",
                franchised: "",
                j1_present: false,
                j1_arrival_time: "",
                j1_diner: false,
                j1_night: false,
                j2_present: false,
                j2_arrival_time: "",
                j2_lunch: false,
                j2_breakfast: false,
                j2_diner: false,
                j3_present: false,
                j3_arrival_time: "",
                j3_breakfast: false,
                j3_activity: false,
                is_accompanied: false,
                mate_first_name: "",
                mate_last_name: "",
                transport: null,
            },
        };
    },
    methods: {
        participate(is_participating) {
            this.form_data.is_participating = is_participating;
            this.form_data.has_accepted_privacy_policy &&= is_participating;
        },
        isAccompaniedChanged(is_accompanied) {
            if (this.form_data.is_accompanied === is_accompanied) return;
            this.form_data.is_accompanied = is_accompanied;
            is_accompanied ? this.mates.push({ last_name: "", first_name: "" }) : (this.mates = []);
        },
        async register() {
            if (!this.isLoading) {
                this.isLoading = true;
                const form = document.querySelector(".needs-validation");
                form.classList.add("was-validated");

                const notif = {
                    isValid: false,
                    participate: this.form_data.is_participating,
                };

                if (form.checkValidity()) {
                    if (this.form_data.is_accompanied) {
                        this.form_data.mate_last_name = this.mates[0].last_name;
                        this.form_data.mate_first_name = this.mates[0].first_name;
                    }

                    const data = {
                        ...this.form_data,
                        typeInvitation: this.type_invitation
                    };

                    await saveRegistration(data)
                        .then(async (result) => {
                            const data = result.data;
                            if (data.isValid) {
                                notif.isValid = true;
                            }
                        })
                        .catch((error) => {
                            const code = error.code;
                            const message = error.message;
                            const details = error.details;
                            console.log(code, message, details);
                            this.$data.hasError = true;
                        });

                    localStorage.p = JSON.stringify(notif);
                    this.cleanData();
                    router.push({ name: "done" });
                }

                this.isLoading = false;
            }
        },
        cleanData() {
            this.form_data = Object.assign({}, empty_form);
            const form = document.querySelector(".needs-validation");
            form?.classLis?.remove("was-validated");
        },
    },
    asyncComputed: {
        async type_invitation() {
            var _type_invitation = 0;

            if (this.token) {
                _type_invitation = await checkTypeInvitation(this.token).then((result) => {
                    const data = result.data;
                    if (data == -1) {
                        localStorage.setItem("isErrorUrl", true);
                        router.push({ name: "404" });
                    } else {
                        return data;
                    }
                });
            } else _type_invitation = 0;

            return _type_invitation;
        },
    },
};
</script>
